import type { ConsentService } from '../consent/consent.service';

declare global {
  interface Window {
    onUsersnapLoad?: (api: { init: () => void }) => void;
  }
}

const SCRIPT_MARKER = 'data-pickapeak-usersnap';

/**
 * Usersnap feedback widget: inject script only when feedback consent is granted.
 */
export function initializeUsersnapWithConsent(consent: ConsentService, globalLoadId: string): void {
  let loadStarted = false;

  const run = (): void => {
    if (!globalLoadId || loadStarted || !consent.feedbackWidgetAllowed()) {
      return;
    }
    if (document.querySelector(`script[${SCRIPT_MARKER}]`)) {
      return;
    }

    loadStarted = true;
    window.onUsersnapLoad = (api) => {
      api.init();
    };

    const script = document.createElement('script');
    script.defer = true;
    script.setAttribute(SCRIPT_MARKER, globalLoadId);
    script.src = `https://widget.usersnap.com/global/load/${globalLoadId}?onload=onUsersnapLoad`;
    document.head.appendChild(script);
  };

  run();
  consent.changed$.subscribe(() => run());
}
